<template>
    <div>
        <div v-if="loading" class="text-center py-4">
            <div class="spinner-border" role="status">
                <span class="sr-only">{{ trans('Loading...') }}</span>
            </div>
            <p class="mt-2 text-muted">{{ trans('Loading preview...') }}</p>
        </div>

        <div v-else-if="previewRows.length === 0" class="text-center text-muted py-4">
            {{ trans('No preview data available') }}
        </div>

        <div v-else class="table-responsive">
            <table class="table table-sm table-bordered">
                <thead class="thead-light">
                    <tr>
                        <th style="width: 60px;">#</th>
                        <th v-for="field in mappedFields" :key="field.key">
                            {{ field.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in previewRows" :key="row.row_number">
                        <td class="text-muted">{{ row.row_number }}</td>
                        <td v-for="field in mappedFields" :key="field.key">
                            <span v-if="row.data[field.key]">
                                {{ row.data[field.key] }}
                            </span>
                            <span v-else class="text-muted font-italic">
                                -
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p class="text-muted small mb-0">
                {{ trans('Showing first 10 rows. Total rows to import:') }} {{ totalRows }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        previewRows: {
            type: Array,
            default: () => [],
        },
        prixoFields: {
            type: Array,
            required: true,
        },
        columnMapping: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        totalRows: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        mappedFields() {
            return this.prixoFields.filter(field => {
                const mapping = this.columnMapping[field.key];
                return mapping !== null && mapping !== undefined && mapping !== '' && mapping !== -1;
            });
        },
    },
};
</script>
